// extracted by mini-css-extract-plugin
export default {"mobile":"tV1Zd","root":"_2dU-D","onImage":"_3CdZL"};